/**
 * lib/records.ts — the two records a deck can carry: the big one at 33 and the small one at 45.
 *
 * Task 21. `spec.md` «Пластинка», «33 и 45»: the buttons change the record, not the sound. A big
 * record turns at 33⅓ a minute, one turn in 1,8 s; a small one at 45, in 1,333 s. Both play the
 * track at its own speed, so what the size changes is only how far a turn of the record carries
 * the track — for the finger (`lib/platter.ts`, the table of task 09), for the scratch voice
 * (`engine/scratch.ts`) and for the needle's grooves (`lib/tonearm.ts`).
 */

/** 33 or 45: which record is on the platter. */
export type RecordSize = '33' | '45';

/** The record at first launch, and wherever the phone cannot say: dancehall came out on 45s. */
export const DEFAULT_RECORD: RecordSize = '45';

/** One turn of each record, in seconds: 60 / 33⅓ and 60 / 45. */
export const TURN_S: Readonly<Record<RecordSize, number>> = Object.freeze({
  '33': 60 / (100 / 3),
  '45': 60 / 45,
});

/** A record's own speed in degrees a second: 200 at 33, 270 at 45. */
export function nominalDegPerS(size: RecordSize): number {
  return 360 / TURN_S[size];
}

/** `value` read as a record, or `undefined` for anything else. */
export function asRecordSize(value: unknown): RecordSize | undefined {
  return value === '33' || value === '45' ? value : undefined;
}
